module.exports = __webpack_public_path__ + "static/img/home_gg_2.6406c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_gg_2.png
// module id = wJay
// module chunks = 1